export const games = {
    yx: '游戏',
    yxms: '加密游戏所有决定结果的参赛提前以哈希的形式生成，不会以任何人的意志改变游戏结果，保证绝对的公平公正！',
    mnsm: '模拟试玩',
    ljqw: '立即去玩',
    loading: '加载中，请等待',
    dyh: '多样化期权合约供您选择，百倍收益，短期超高投资回报率',
    qyhy:'期权合约',
    qsyhys:'期权',
    kd:'开单',
    qt:'趣投',
    ljjy: "立即交易",
} 


// WEBPACK FOOTER //
// ./src/i18n/lang/games/zh.js